import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'OrderByDatePipe'
})
        
export class OrderByDatePipe implements PipeTransform {

  transform(array, orderByDt) {

    if (!array || array === undefined || array.length === 0) return null;

    array.sort((a: any, b: any) => {
      if (a[orderByDt] > b[orderByDt]) {
        return -1;
      } else if (a[orderByDt] < b[orderByDt]) {
        return 1;
      } else {
        return 0;
      }
    });
    return array;
  }
}


// WEBPACK FOOTER //
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/app/common/pipe/order-by-date.pipe.ts